export type SurfaceInputs = {
  wall: boolean;
  floor: boolean;
  ceiling: boolean;
  wall_single: boolean;
  wall_linear: boolean;
  land_plot: boolean;
};

export enum ESurfacesTypes {
  wall = 'wall',
  floor = 'floor',
  ceiling = 'ceiling',
  wall_single = 'wall_single',
  wall_linear = 'wall_linear',
  land_plot = 'land_plot',
}

export type TSurfaces = Array<{
  name: ESurfacesTypes;
  label: string;
  materialLabel: string;
}>;
